import { defineMessages } from 'react-intl';

export const messages: {
	uploadMediaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	uploadMediaLabel: {
		id: 'company-hub.company-hub-common.unsplash.upload.label',
		defaultMessage: 'Upload',
		description:
			'Opens a dialog to be able to select an image from a users computer to upload and use',
	},
});
